var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('main', [_c('b-alert', {
    staticClass: "mb-2",
    attrs: {
      "show": ""
    }
  }, [_c('div', {
    staticClass: "p-2"
  }, [_c('h1', {
    staticClass: "text-dark"
  }, [_c('strong', [_vm._v("Halo " + _vm._s(_vm.myName))])]), _c('h4', {
    staticClass: "text-secondary"
  }, [_vm._v("Selamat Datang Kembali!")])])]), _vm.level.nama_level == 'Admin' ? _c('div', [_c('admin')], 1) : _vm.level.nama_level == 'Owner' ? _c('div', [_c('owner')], 1) : _vm.level.nama_level == 'Finance' ? _c('div', [_c('finance')], 1) : _vm.level.nama_level == 'General Manager' ? _c('div', [_c('gm')], 1) : _vm.level.nama_level == 'Sales' ? _c('div', [_c('sales')], 1) : _vm.level.nama_level == 'Admin Gudang' ? _c('div', [_c('gudang')], 1) : _vm.level.nama_level == 'SPV' ? _c('div', [_c('spv')], 1) : _vm.level.nama_level == 'Human Resource' ? _c('div', [_c('human')], 1) : _c('div', [_c('aset')], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }